import React from "react";
import { Phone, Mail } from "react-feather";

const TopHeader = () => {
    return (
        <div className="top-header py-2 lanp-bg-secondary">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 d-none d-lg-block ">
                        <ul className="text-white list-unstyled mb-0 d-flex gap-3">
                            <li className="d-flex align-items-center">
                                <Phone size={16} className="me-2" />
                                <b className="me-1">Call:</b>
                                <a
                                    href="tel:+919108799731"
                                    className="fw-bold text-white text-decoration-none text-white"
                                >
                                    +91 91087 99731
                                </a>
                            </li>
                            <li className="d-flex align-items-center">
                                <Mail size={16} className="me-2" />
                                <b className="me-1">Email:</b>
                                <a
                                    href="mailto:sales@azsmenterprises.com"
                                    className="fw-bold text-white text-decoration-none text-white"
                                >
                                    sales@azsmenterprises.com
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div
                        className="col-lg-7 text-white fw-semibold"
                        style={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                        }}
                    >
                        <div
                            style={{
                                display: "inline-block",
                                paddingLeft: "100%",
                                animation: "marquee 30s linear infinite",
                            }}
                        >
                            AZSM Hospital Management Software is a powerful, user-friendly healthcare solution designed to streamline hospital operations, improve patient care, enhance digital presence, and boost efficiency for clinics, hospitals, and medical institutions.
                        </div>

                        <style>
                            {`
                                @keyframes marquee {
                                    0%   { transform: translateX(0%); }
                                    100% { transform: translateX(-100%); }
                                }
                                `}
                        </style>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default TopHeader;